import { AccountAppearanceState } from "@/features/Labeling/Labeling.types";
import clsx from "clsx";

export const RowHeaderColDef = {
    field: "rowHeader",
    headerName: "Original Line Item",
    colId: "rowHeader",
    minWidth: 260,
    suppressHeaderMenuButton: true,
    sortable: false,
    resizable: false,
    valueGetter: (params) => {
        return params.data.rowHeader;
    },
};

export const RowHeaderCellRenderer = ({
    rowHeader,
    appearanceState,
    canChangeAccount,
}: {
    rowHeader?: string | null;
    appearanceState: AccountAppearanceState;
    canChangeAccount: boolean;
}) => {
    if (!rowHeader)
        return (
            <div
                className={clsx(
                    "size-full",
                    canChangeAccount ? "cursor-default" : "cursor-pointer",
                )}
            />
        );

    return (
        <div
            className={clsx(
                "size-full",
                appearanceState === AccountAppearanceState.DEFAULT
                    ? "opacity-100"
                    : "opacity-50",
                canChangeAccount ? "cursor-default" : "cursor-pointer",
            )}
        >
            {rowHeader}
        </div>
    );
};
